// Module
var code = `<div>
  <div class="filters">
     <div class="labelled-field">
      <label class="add-on">Name</label>
      <input type="text" ng-model="\$ctrl.filter.text">
    </div>

    <button type="button"
            class="btn btn-success category-list__action"
            command-access="CreateActionCategory"
            ng-click="\$ctrl.add()">
      Add
    </button>
  </div>

  <table ng-table="\$ctrl.tableConfig" class="table table--last-column-to-right">
    <tr ng-repeat="category in \$data">
      <td data-title="'No'">{{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}</td>
      <td data-title="'Name'" sortable="'name'">{{category.name}}</td>
      <td data-title="'Action Name'" sortable="'actionType'">{{category.actionType | translate:'ACTION_TYPE' | replaceWithInvoice}}</td>
      <td data-title="'Ledger full code'">{{category.ledgerAccountFullCodes.join('\\n')}}</td>
      <td data-title="'Action'" class="table__actions">
        <button type="button"
                class="btn btn-warning category-list__action"
                command-access="UpdateActionCategory"
                ng-click="\$ctrl.edit(category)">
          Edit
        </button>
        <button type="button"
                class="btn btn-danger category-list__action"
                command-access="RemoveActionCategory"
                ng-click="\$ctrl.remove(category)">
          Remove
        </button>
      </td>
    </tr>
  </table>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/transactions/transactions-category-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;